<template>
  <section class="content-plans">
    <div class="content-plans-itens">
      <Breadcrumb :links="links" />
      <div class="content-plans-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3">
            <router-link
              tag="a"
              :to="{ name: 'RegisterCompanyPlans' }"
              class="content--card-register"
              style="min-height: 200px"
            >
              <img
                class="img-fluid"
                src="@/assets/img/image-plus.png"
                alt="image plus"
                title="image plus"
              />
            </router-link>
          </div>
          <template v-if="hasPlans">
            <div
              class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3"
              v-for="plan in plans"
              :key="plan.id"
            >
              <CardPlan :plan="plan" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import CardPlan from "@/views/Company/components/CardPlan";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Listar Planos",
          routerName: "ListCompanyPlans",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      plans: "Company/plans",
    }),
    hasPlans() {
      return this.plans && Array.isArray(this.plans) && this.plans.length > 0;
    },
  },
  components: {
    Breadcrumb,
    CardPlan,
  },
  methods: {
    ...mapActions("Company", ["consultPlans"]),
  },
  mounted() {
    this.consultPlans();
  },
};
</script>
